import { KEYS } from 'app/constants/SceneConstants';
import { ItemSelectButton } from '../input/ItemSelectButton';
import SceneBaseTT from './SceneBaseTT';

const characterOrder = ['raven', 'robin', 'beastboy', 'cyborg', 'starfire'];

export default class ItemUnlocks extends SceneBaseTT {
  constructor() {
    super({ key: KEYS.ItemUnlocks, active: false });
  }

  create() {
    super.create();
    this.setBackgroundImage('background_blue');
    this.game.hud.setState('UNLOCKS');
    const inputzone = this.add.zone(840, 360, 1680, 720);
    inputzone.setInteractive({});
    inputzone.on('pointerup', this.handlePointerUp, this);
    this.container = this.add.container();
    this.container.y = 512;
    this.container.x = 500;
    const heroes = this.game.model.getHeroes().filter((h) => h.cost > 0);
    this.buttons = heroes.map((hero, i) => {
      const btn = new ItemSelectButton(this, {
        x: 200 * i,
        y: 0,
        id: hero.id,
        locked: !this.game.player.hasUnlockedHero(hero.id),
        cost: hero.cost,
        label: 'character_name_' + hero.id,
      });
      btn.on('click', this.handleCharcterSelect, this);
      this.container.add(btn);
      return btn;
    });

    const weapons = this.game.model.getWeapons();
    weapons.forEach((weapon, i) => {
      weapon.skins.forEach((skin) => {
        const btn = new ItemSelectButton(this, {
          x: 200 * this.buttons.length,
          y: 0,
          id: weapon.id + '||' + skin.skin,
          thumb: { sheet: 'character_thumbs', frame: 'item_unlock_skin_' + skin.skin },
          locked: !this.game.player.hasUnlockedWeaponSkin(weapon.id, skin.skin),
          cost: skin.cost,
          label: 'label_category_skin',
          type: 'skin',
        });
        btn.on('click', this.handleWeaponSkinSelect, this);
        this.container.add(btn);
        this.buttons.unshift(btn);
      });
    });

    const unlockableComboFinsihers = this.game.model.getUnlockableComboMoves();
    unlockableComboFinsihers.sort(
      (a, b) => characterOrder.indexOf(a.heroid) - characterOrder.indexOf(b.heroid)
    );
    unlockableComboFinsihers.forEach((entry, i) => {
      entry.moves.forEach((move, i) => {
        const btn = new ItemSelectButton(this, {
          x: 200 * this.buttons.length,
          y: 0,
          id: entry.heroid + '||' + move.id,
          thumb: { sheet: 'character_thumbs', frame: 'combo_unlock_' + entry.heroid },
          locked: !this.game.player.hasUnlockedComboFinsiher(entry.heroid, move.id),
          cost: move.cost,
          label: 'label_category_combofinisher',
          type: 'combofinisher',
        });
        btn.on('click', this.handleComboFinsiherSelect, this);
        this.container.add(btn);
        this.buttons.unshift(btn);
      });
    });

    this.game.hud.events.on('btn_cycle_next', this.handleScrollForward, this);
    this.game.hud.events.on('btn_cycle_prev', this.handleScrollBack, this);

    this.pageIndex = 0;
    this.pages = Math.ceil(this.buttons.length / 4);
    this.game.soundController.playMusic('character_select');
    this.updateCycleButtons();
  }

  handlePointerUp(pointer) {
    if (Math.abs(pointer.downX - pointer.upX) > 128) {
      if (pointer.downX < pointer.upX) this.handleScrollBack();
      else this.handleScrollForward();
      return true;
    }
    return false;
  }

  handleScrollForward() {
    if (this.pageIndex === this.pages - 1 || this._tweenActive) return;
    this.pageIndex++;
    this.tweenToPosition(512 - this.pageIndex * 800);
    this.updateCycleButtons();
  }

  handleScrollBack() {
    if (this.pageIndex === 0 || this._tweenActive) return;
    this.pageIndex--;
    this.tweenToPosition(512 - this.pageIndex * 800);
    this.updateCycleButtons();
  }

  tweenToPosition(position) {
    this._tweenActive = true;
    this.tweens.killTweensOf(this.container);
    this.tweens.add({
      targets: this.container,
      x: position,
      duration: 250,
      ease: Phaser.Math.Easing.Out,
      onComplete: () => (this._tweenActive = false),
      onConfirmScope: this,
    });
  }

  updateCycleButtons() {
    this.game.hud.getButton('btn_cycle_next').visible = this.pageIndex < this.pages - 1;
    this.game.hud.getButton('btn_cycle_prev').visible = this.pageIndex > 0;
  }

  handleCharcterSelect(btn) {
    if (this.handlePointerUp(this.input.activePointer)) return;
    const hasunlocked = this.game.player.hasUnlockedHero(btn.id);
    const canPurchase = this.game.model.canPurchaseHero(btn.id, this.game.player.coins);
    console.log('handleCharcterSelect');
    if (!hasunlocked) {
      if (canPurchase) {
        return this.game.sceneController.showOverlayScene(KEYS.ConfirmAction, {
          data: {
            type: 'unlock',
            price: btn.cost,
            onConfirm: () => this.purchaseCharacter(btn.id),
            onConfirmScope: this,
          },
        });
      } else this.showNoMoneyPopup(btn.cost);
    }
  }

  handleWeaponSkinSelect(btn) {
    if (this.handlePointerUp(this.input.activePointer)) return;
    const unlock = btn.id.split('||');
    if (this.game.player.hasUnlockedWeaponSkin(unlock[0], unlock[1])) return;
    const canPurchase = this.game.player.coins >= btn.cost;
    if (canPurchase) {
      return this.game.sceneController.showOverlayScene(KEYS.ConfirmAction, {
        data: {
          type: 'unlock',
          price: btn.cost,
          onConfirm: () => this.purchaseWeaponSkin(unlock[0], unlock[1], btn.cost),
          onConfirmScope: this,
        },
      });
    } else this.showNoMoneyPopup(btn.cost);
  }

  handleComboFinsiherSelect(btn) {
    if (this.handlePointerUp(this.input.activePointer)) return;
    const unlock = btn.id.split('||');
    if (this.game.player.hasUnlockedComboFinsiher(unlock[0], unlock[1])) return;
    const canPurchase = this.game.player.coins >= btn.cost;
    if (canPurchase) {
      return this.game.sceneController.showOverlayScene(KEYS.ConfirmAction, {
        data: {
          type: 'unlock',
          price: btn.cost,
          onConfirm: () => this.purchaseComboFinsiher(unlock[0], unlock[1], btn.cost),
          onConfirmScope: this,
        },
      });
    } else this.showNoMoneyPopup(btn.cost);
  }

  showNoMoneyPopup(cost) {
    this.game.sceneController.showOverlayScene(KEYS.ConfirmAction, {
      data: {
        type: 'nomoney',
        price: cost,
      },
    });
  }

  purchaseCharacter(characterid) {
    const hero = this.game.model.getHeroConfig(characterid);
    this.game.player.adjustCoins(-hero.cost);
    this.game.player.unlockHero(hero.id);
    const btn = this.buttons.filter((b) => b.id === characterid);
    btn.forEach((b) => b.unlock());
  }

  purchaseWeaponSkin(weaponid, skinid, cost) {
    this.game.player.unlockWeaponSkin(weaponid, skinid);
    this.game.player.adjustCoins(-cost);
    const btn = this.buttons.filter((b) => b.id === weaponid + '||' + skinid);
    btn.forEach((b) => b.unlock());
  }

  purchaseComboFinsiher(heroid, finisherid, cost) {
    this.game.player.unlockComboFinsiher(heroid, finisherid);
    this.game.player.adjustCoins(-cost);
    const btn = this.buttons.filter((b) => b.id === heroid + '||' + finisherid);
    btn.forEach((b) => b.unlock());
  }

  shutdown() {
    this._tweenActive = false;
    this._selectedCharacter = null;
    super.shutdown();
  }
}
